import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DID_TYPE } from 'voxloud-types/dist/models';

@Pipe({ name: 'didType' })
export class DidTypePipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  transform(value: DID_TYPE): string {
    const token = `common.did-types.${value.replace('_', '-').toLowerCase()}`
    return this.translate.instant(token).toUpperCase();
  }
}
